import { Currency } from '@/core/currency/interfaces';

const FJD: Currency = {
    name: 'Fijian Dollar',
    demonym: 'Fijian',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '242',
    symbol: 'FJ$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'FJD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default FJD;
